import React from "react";
import { WidgetComponent } from "../../widget.component";
import {
  DEFAULT_ERROR_MESSAGE,
  ERROR_CALLOUT_HEADING,
  loanOptionsCopy,
  loanOptionsDisclaimer,
  referralTitle,
  loanOptionsList,
  SCORES_REFERRAL_PRODUCT,
} from "./partner-referral-widget-loan-options.consts";
import loanOptions from "../../../assets/images/loanoptions-dash.svg";
import localStyle from "./partner-referral-widget-loan-options.scss";
import { Button, StatusCallout } from "@wisr/react-ui";
import { submitForPartnerReferral } from "../../../redux/partner-referral/partner-referral-widget.thunk";
import { clearPartnerReferralError } from "../../../redux/partner-referral/partner-referral.slice";
import { useDispatch } from "react-redux";
import { useGetWisrProfile } from "../../../redux/wisr-profile/wisr-profile.hooks";
import { FetchStatus } from "../../../shared/redux.consts";
import { useGetPartnerReferral } from "../../../redux/partner-referral/partner-referral-widget.hooks";
import { LoaderFullPage } from "../../../shared/loader-full-page/loader-full-page";
import {
  gtmSendEvent,
  triggerLoanOptionsDeclineReferralEvent,
  triggerLoanOptionsExperimentLoadedEvent,
} from "../../../shared/analytics/analytics.utils";
import { Events } from "../../../shared/analytics/analytics.consts";

interface PartnerReferralWidgetLoanOptionsProps {
  pageName: string;
}

export const PartnerReferralWidgetLoanOptions: React.FC<
  PartnerReferralWidgetLoanOptionsProps
> = ({ pageName }: PartnerReferralWidgetLoanOptionsProps) => {
  const wisrProfile = useGetWisrProfile();
  const dispatch = useDispatch();
  const partnerReferralState = useGetPartnerReferral();
  const partnerReferralLoading =
    partnerReferralState.status === FetchStatus.LOADING;
  const hasError =
    !partnerReferralLoading &&
    partnerReferralState.status === FetchStatus.FAILED;
  const errorCalloutMessage =
    partnerReferralState.error ?? DEFAULT_ERROR_MESSAGE;

  const onSubmit = () => {
    dispatch(clearPartnerReferralError());
    if (wisrProfile?.wisrCustomerId) {
      dispatch(
        submitForPartnerReferral({
          application: "credit-profile",
          wisrCustomerId: wisrProfile.wisrCustomerId,
        })
      );

      triggerLoanOptionsDeclineReferralEvent(
        true,
        Events.CLICKED_DECLINE_REFERRAL_OFFER,
        pageName
      );
    }
  };

  React.useEffect(() => {
    gtmSendEvent(Events.PRESENTED_LOAN_OPTIONS, {
      productOffer: SCORES_REFERRAL_PRODUCT,
    });

    triggerLoanOptionsExperimentLoadedEvent(true);

    triggerLoanOptionsDeclineReferralEvent(
      true,
      Events.PRESENTED_DECLINE_REFERRAL_OFFER,
      pageName
    );
  }, [pageName]);

  return (
    <WidgetComponent widgetName="partner-referral" widgetType="other">
      <style jsx>{localStyle}</style>
      <div className="referral-widget-alternate">
        <img
          src={loanOptions}
          className="widget-image"
          alt="loan options logo"
        />
        <h2 className="widget-title">{referralTitle}</h2>
        <div className="widget-text">{loanOptionsCopy}</div>
        <div className={`list ${hasError ? "error-list-margin" : ""}`}>
          {loanOptionsList}
        </div>
        {hasError && (
          <div className="error-callout-wrapper">
            <StatusCallout
              type="error"
              theme="outline"
              heading={ERROR_CALLOUT_HEADING}
              message={errorCalloutMessage}
            />
          </div>
        )}
        <Button theme="navy" fullWidth={true}>
          <button type="button" onClick={onSubmit}>
            Explore LoanOptions.ai
          </button>
        </Button>
        <p className="widget-disclaimer">{loanOptionsDisclaimer}</p>
      </div>
      <LoaderFullPage enabled={partnerReferralLoading} />
    </WidgetComponent>
  );
};
